import { motion } from "framer-motion";
import { Car, Banknote, FileCheck2, ShieldCheck, Plane, Users } from "lucide-react";
import { SERVICES } from "@/lib/data";
import SectionHeading from "@/components/SectionHeading";

const iconMap = { Car, Banknote, FileCheck2, ShieldCheck, Plane, Users };

export default function Services() {
  return (
    <div data-testid="services-page">
      <section className="relative pt-32 pb-16 md:pt-40 md:pb-20 overflow-hidden">
        <div className="absolute inset-0 grid-bg opacity-60" />
        <div className="absolute -top-40 right-1/4 w-[600px] h-[600px] radial-glow-red pointer-events-none" />

        <div className="relative max-w-6xl mx-auto px-6 lg:px-10">
          <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.28em] text-red-500 mb-4 font-mono-brand">
            <span className="w-8 h-px bg-current" /> Services
          </div>
          <h1 className="font-display text-5xl md:text-6xl lg:text-7xl font-black tracking-tighter leading-[1.05] text-white">
            One trusted partner. <span className="text-gradient-red">Every step covered.</span>
          </h1>
          <p className="mt-6 text-lg text-slate-400 max-w-3xl leading-relaxed">
            From your first enquiry to your first commercial ride — Be Easy Cars
            handles vehicle sales, finance, RTO, insurance and business setup.
          </p>
        </div>
      </section>

      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {SERVICES.map((s, i) => {
            const Icon = iconMap[s.icon] || Car;
            return (
              <motion.div
                key={s.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.06 }}
                className="group relative overflow-hidden rounded-3xl glass glass-hover p-8"
                data-testid={`services-page-card-${i}`}
              >
                <div className="w-14 h-14 rounded-2xl bg-red-600/15 border border-red-500/30 flex items-center justify-center mb-6 group-hover:bg-red-600 group-hover:border-red-500 transition-colors">
                  <Icon className="w-6 h-6 text-red-400 group-hover:text-white transition-colors" />
                </div>
                <h3 className="font-display text-2xl font-bold text-white mb-3">{s.title}</h3>
                <p className="text-slate-400 leading-relaxed">{s.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </section>
    </div>
  );
}
